import React, { Component } from 'react';
import '@babel/polyfill';
import {
  getSyncComponentSearch,
  getSyncComponentState,
} from '../helpers/Common';
import EventEmitter, { ON_TAB_FOCUS_BLUR } from '../helpers/EventEmitter';
import { setSyncState } from './commonReducer';
import { connect } from 'react-redux';
import Router from './routes';
import './../../assets/libraries/fiintrade-icon/style.css';
import '../../styles/style.scss';
import { TimeReloadOnFocusBlur } from '../../configs/GlobalConfig';

class App extends Component {
  constructor(props) {
    super(props);
    const { setSyncState } = this.props;
    const payload = {
      syncComponent: getSyncComponentState(),
      syncComponentSearch: getSyncComponentSearch(),
    };
    setSyncState(payload);
  }

  componentDidMount() {
    window.addEventListener('focus', this.onFocusBrowser);
    window.addEventListener('blur', this.onBlurBrowser);
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.onFocusBrowser);
    window.removeEventListener('blur', this.onBlurBrowser);
  }

  onFocusBrowser() {
    const secondsNoFocusBrowser = new Date().getTime() - this.startBlurTime;
    if (secondsNoFocusBrowser >= TimeReloadOnFocusBlur.TimeIntervalReloadData) {
      EventEmitter.dispatch(ON_TAB_FOCUS_BLUR);
    }
    clearInterval(this.intervalInactive);
  }

  onBlurBrowser() {
    this.startBlurTime = new Date().getTime();
    this.intervalInactive = setInterval(() => {
      EventEmitter.dispatch(ON_TAB_FOCUS_BLUR);
    }, TimeReloadOnFocusBlur.TimeIntervalReloadData);
  }

  render() {
    return <Router />;
  }
}

const mapDispatchToProps = {
  setSyncState,
};

export default connect(
  null,
  mapDispatchToProps,
)(App);
